import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"height":"calc(100vh - 56px)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        dark: "",
        flat: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            icon: "",
            onClick: _ctx.routerBack
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, {
            class: "flex-grow-1 text-center ml-0",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" 支払設定 ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            icon: "",
            disabled: "",
            style: {"visibility":"hidden"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_vue_loading, {
            loader: "bars",
            active: _ctx.loading,
            color: "#EE6090",
            size: { width: '30px', height: '30px' }
          }, null, 8, ["active"])
        ]))
      : (_openBlock(), _createBlock(_component_v_list, {
          key: 1,
          density: "compact",
          class: "content_wrapper pa-0"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payments, (p, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: p.child.childId
              }, [
                _createVNode(_component_v_list_item, {
                  onClick: ($event: any) => (_ctx.to(p.child.childId, p.child.lastName + p.child.firstName))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_avatar, { class: "ml-2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: 
                  p.child.imageUrl
                    ? p.child.imageUrl
                    : 'https://via.placeholder.com/240x180?text=Sample+Image+1'
                
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, {
                      textContent: _toDisplayString(p.child.lastName + p.child.firstName)
                    }, null, 8, ["textContent"]),
                    _createVNode(_component_v_list_item_subtitle, {
                      class: "text-grey body-2",
                      textContent: _toDisplayString(_ctx.getPaymentCategoryStr(p.category))
                    }, null, 8, ["textContent"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_v_divider)
              ], 64))
            }), 128))
          ]),
          _: 1
        }))
  ]))
}